export enum ESourceType {
  Manuel = 0,
  GoogleDrive = 1,
  Aws = 2,
  YouTube = 3,
  Website = 4,
  Action = 5
}
